import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Currency = () => {
  const [activeMenu, setActiveMenu] = useState('currency');
  const [settings, setSettings] = useState({
    defaultCurrency: false,
    activeCurrencies: false,
    supportedPayments: false,
    geoLocation: false,
  });

  const toggleSetting = (setting) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [setting]: !prevSettings[setting],
    }));
  };

  return (
    <div className="flex bg-gray-100">
      {/* Sidebar */}
      {/* Sidebar */}
      <div className="w-1/5 bg-gray-100 border-r text-black hover:text-gray-800 p-4">
        <h1 className="text-xl font-bold mb-4">Settings</h1>
        <div>
          {/* Sidebar Links */}
          <Link
            to="/dashboard/system-config/wide-settings"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            General
          </Link>
          <Link
            to="/dashboard/system-config/preferences"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Preferences
          </Link>

          <Link
            to="/dashboard/system-config/notifications"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Notifications
          </Link>

          <Link
            to="/dashboard/system-config/language"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Language Settings
          </Link>

          <Link
            to="/dashboard/system-config/currency"
            className="w-full block text-left py-2 px-4 mb-2 rounded bg-black text-white "
          >
            Currency Settings
          </Link>

          <Link
            to="/dashboard/system-config/hotel-config"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Hotel Configuration
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-5/6 bg-gray-50 p-8">
        {/* Header */}
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h2 className="text-2xl text-black font-bold">Settings &gt; Currency</h2>
            <p className="text-gray-500 font-semibold">Customize until match to your workflows</p>
          </div>
          <div className="flex space-x-4">
            <button className="px-6 py-2 bg-cyan-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
              Save
            </button>
            <button className="px-6 py-2 bg-red-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
              Cancel
            </button>
          </div>
        </div>

        {/* Currency Section */}
        <div className="bg-white p-5">
          <h1 className="text-xl font-bold text-black">Currency</h1>
          <p className="text-gray-500 font-semibold">
            Manage the currencies accepted on your website.
          </p>
          <hr className="border-t border-gray-300 my-1 mb-6" />

          {/* Currency Options */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold">For Customers Invoice and Receipt</h2>
            <div className="flex flex-col mt-4 space-y-4">
              <label className="flex items-center justify-between">
                <span>Enable Currency Selector for Customers</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.currencySelector}
                    onChange={() => toggleSetting('currencySelector')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </label>
              <label className="flex items-center justify-between">
                <span>Show Price Estimates in Customer Currency</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.priceEstimates}
                    onChange={() => toggleSetting('priceEstimates')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </label>
              <label className="flex items-center justify-between">
                <span>Use Local Currency for Receipts</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.localCurrency}
                    onChange={() => toggleSetting('localCurrency')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </label>
              <label className="flex items-center justify-between">
                <span>Display Customer Currency on Invoice</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.displayCurrency}
                    onChange={() => toggleSetting('displayCurrency')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </label>
            </div>
          </div>

          {/* Additional Settings */}
          <div>
            <h2 className="text-lg font-semibold">Additional Settings</h2>
            <div className="mt-4 space-y-4">
              <div className="flex items-center justify-between">
                <span>Default Currency</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.defaultCurrency}
                    onChange={() => toggleSetting('defaultCurrency')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <span>Active and Inactive Currencies</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.activeCurrencies}
                    onChange={() => toggleSetting('activeCurrencies')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <span>Supported Currencies for Payments</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.supportedPayments}
                    onChange={() => toggleSetting('supportedPayments')}
                  />
                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <span>Geo-location Currency Detection</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.geoLocation}
                    onChange={() => toggleSetting('geoLocation')}
                  />

                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <span>Geo-location Currency Detection</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.geoLocation}
                    onChange={() => toggleSetting('geoLocation')}
                  />

                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <span>Geo-location Currency Detection</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={settings.geoLocation}
                    onChange={() => toggleSetting('geoLocation')}
                  />

                  <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Currency;
